import { TipoRicorso } from "src/app/common/models/tipologiche/tipo-ricorso.";
import { Grado } from "../../common/models/tipologiche/grado";
import { MotivoScadenza } from "../../common/models/tipologiche/motivo-scadenza";
import { TipoAtto } from "../../common/models/tipologiche/tipo-atto";
import { TipoEsito } from "../../common/models/tipologiche/tipo-esito";
import { TipoFascicolo } from "../../common/models/tipologiche/tipo-fascicolo";
import { TipoPratica } from "../../common/models/tipologiche/tipo-pratica";
import { TipoScadenza } from "../../common/models/tipologiche/tipo-scadenza";

export class ConfigurazioneScadenzarioSearch {
    tipoAtto: TipoAtto;
    tipoEsito: TipoEsito;
    tipoScadenza: TipoScadenza;
    motivoScadenza: MotivoScadenza;
    tipoPratica: TipoPratica;
    tipoFascicolo: TipoFascicolo;
    tipoRicorso: TipoRicorso;
    grado: Grado;

    constructor(){
    }

}